<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            persistent
            :width="trucks.length ? '750' : '500'">
            <v-card>
                <v-card-title>
                    {{ $t('search_truck') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchItem"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.searchTruck"
                        :label="$t('search')">
                    </v-text-field>
                    <v-data-table
                        v-if="trucks.length"
                        dense
                        hide-default-footer
                        :items="trucks"
                        disable-pagination
                        :height="trucks.length ? '300' : '100'"
                        v-model="selected.truck"
                        :headers="headers.truck"
                        show-select
                        single-select>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="submit({target: 'submit'})" text>
                        {{ $t('btn_select') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('BTN_CLOSE') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="authorizations.trucks.create" @click="openTruckDialog({editMode: false})" text>
                        <v-icon>mdi-database-plus</v-icon>
                        {{ $t('TRUCK_TITLE_CREATE') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <TruckDialog
            @record="submitAndCreateNewTruck"
            ref="truckDialog"/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import TruckDialog from '@/components/TruckDialog';
export default {
    name: "TruckSearchDialog",
    components: {
        TruckDialog
    },
    data() {
        return {
            display: false,
            search: null,
            selected: {
                truck: []
            },
            loading: {
                truck: false,
                searchTruck: false
            },
            headers: {
                truck: [
                    { text: this.$t('TRUCK_PLATE'), value: 'plate_number' },
                    { text: this.$t('TRUCK_TYPE'), value: 'truck_type' },
                    { text: this.$t('BRAND_NAME'), sortable: false, value: 'truck_brand' },
                    { text: this.$t('MODEL_NAME'), sortable: false, value: 'truck_model' }
                ]
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            },  
        }
    },
    computed: {
        ...mapState("truck", ["trucks"]),
        ...mapState("authentication", ["authorizations"]),
    },
    methods: {
        ...mapActions("truck", ["fetchTrucks", "restTrucks"]),
       open(params){
           this.search = params;
           this.restTrucks();
           this.display = true;
           this.searchItem();
       },
        setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
       async searchItem() {
            if(this.search) {
                this.restTrucks();
                this.clearError();
                this.loading.searchTruck = true;
                try {
                    await this.fetchTrucks({ search: this.search });
                    this.loading.searchTruck = false;
                    if(!this.trucks.length) this.setError(this.$t('no_result'));
                    if(this.trucks.length == 1) this.submit({target: 'submit'});
                } catch(error) {
                    this.loading.searchTruck = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }
            } else {
                this.setError(this.$t('rules_required'))
            }
       },
        openTruckDialog(params) {
            this.$refs.truckDialog.open(params);
        },
        submitAndCreateNewTruck(params){
           this.submit({target: 'submitAndCreate', data: params});
        },
        submit(params) {
           if(params.target == 'submitAndCreate') {
                this.$emit('submit', params.data);
           } else if(params.target == 'submit') {
               if(this.trucks.length == 1) this.$emit('submit', this.trucks[0]);
               else this.$emit('submit', this.selected.truck[0]);
           }
            this.close();
        },
       close() {
            this.display = false;
            this.search = null;
            this.selected.searchTruck = [];
            this.restTrucks();
       }
    },
}
</script>